module.exports = __webpack_public_path__ + "06_face.f7d75df6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer1/06_face.png
// module id = w5+5
// module chunks = 0